import Swiper from "swiper";
import { A11y, EffectFade, Navigation } from "swiper/modules";
import "@styles/components/slider.css";

document.querySelectorAll(".element-featuredmedia").forEach((el) => {
  const imageSwiper = new Swiper(el.querySelector(".item-image-slider .swiper"), {
    modules: [A11y, EffectFade],
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    speed: 500,
    allowTouchMove: false,
  });

  new Swiper(el.querySelector(".item-slider .swiper"), {
    modules: [A11y, EffectFade, Navigation],
    slidesPerView: 1,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    speed: 500,
    allowTouchMove: false,
    navigation: {
      nextEl: el.querySelector(".slider-button-next"),
      prevEl: el.querySelector(".slider-button-prev"),
    },
    on: {
      activeIndexChange: (swiper) => {
        imageSwiper.slideTo(swiper.realIndex);
      },
    },
  });
});
